/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

module.exports = {
  cloud: "\n\
    __                 ________                _          ________                __\n\
   / /___  _________ _/ ____/ /___ _      __  (_)___     / ____/ /___  __  ______/ /\n\
  / / __ \\/ ___/ __ `/ /_  / / __ \\ | /| / / / / __ \\   / /   / / __ \\/ / / / __  / \n\
 / / /_/ / /  / /_/ / __/ / / /_/ / |/ |/ / / / /_/ /  / /___/ / /_/ / /_/ / /_/ /  \n\
/_/\\____/_/   \\__,_/_/   /_/\\____/|__/|__(_)_/\\____/   \\____/_/\\____/\\__,_/\\__,_/   ",
  cube: "\n\
    __                 ________                _          ______      __       \n\
   / /___  _________ _/ ____/ /___ _      __  (_)___     / ____/_  __/ /_  ___ \n\
  / / __ \\/ ___/ __ `/ /_  / / __ \\ | /| / / / / __ \\   / /   / / / / __ \\/ _ \n\
 / / /_/ / /  / /_/ / __/ / / /_/ / |/ |/ / / / /_/ /  / /___/ /_/ / /_/ /  __/\n\
/_/\\____/_/   \\__,_/_/   /_/\\____/|__/|__(_)_/\\____/   \\____/\\__,_/_.___/\\___/ ",
  devCloud: "\n\
 ________________________________\n\
< Hi, developer! UR in the cloud!>\n\
 --------------------------------\n\
        \\   ^__^\n\
         \\  (oo)\\_______\n\
            (__)\\       )\\/\\\n\
                ||----w |\n\
                ||     ||",
  devCube: "\n\
 ______________________\n\
< Cube! Cube!! Cube!!! >\n\
 ----------------------\n\
        \\   ^__^\n\
         \\  ($$)\\_______\n\
            (__)\\       )\\/\\\n\
                ||----w |\n\
                ||     ||"
};




// WEBPACK FOOTER //
// ./src/asciibanner.js